export default __webpack_public_path__ + "static/media/a10.f9451def.png";